import { QRCodeSVG } from "qrcode.react";
import { Printer, QrCode } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { UpgradeHint } from "@/components/UpgradeHint";
import { api } from "@/lib/api";
import { useErrorToast } from "@/lib/hooks";
import { useWs } from "@/context/Auth";
import { useI18n } from "@/i18n/I18n";

export const QrPanel = ({ loc }) => {
  const { t } = useI18n();
  const { features, canWrite } = useWs();
  const qc = useQueryClient();
  const showErr = useErrorToast();
  const url = `${window.location.origin}/l/${loc.id}`;

  const issue = async () => {
    try { await api.post(`/locations/${loc.id}/qr`); qc.invalidateQueries({ queryKey: ["location", loc.id] }); }
    catch (e) { showErr(e); }
  };

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 space-y-4" data-testid="qr-panel">
      <h2 className="flex items-center gap-2 font-bold"><QrCode className="w-4 h-4" />{t("loc.qr")}</h2>
      {loc.qr_issued ? (
        <>
          <div className="print-label mx-auto w-fit rounded-xl border-2 border-slate-900 bg-white p-4 text-center space-y-2" data-testid="qr-label">
            <QRCodeSVG value={url} size={176} level="M" />
            <p className="font-head font-extrabold text-lg max-w-[176px] break-words">{loc.name}</p>
            <p className="font-mono text-[10px] text-slate-500 max-w-[176px] break-words">{loc.path.map((p) => p.name).join(" → ")}</p>
            <p className="font-mono text-[9px] text-slate-400">Rangéo</p>
          </div>
          <p className="text-xs text-slate-500">{t("loc.qrHint")}</p>
          <Button data-testid="qr-print-button" variant="outline" className="w-full h-11 gap-2" onClick={() => window.print()}><Printer className="w-4 h-4" />{t("common.print")}</Button>
        </>
      ) : features.qr ? (
        canWrite && <Button data-testid="qr-generate-button" className="w-full h-11 gap-2" onClick={issue}><QrCode className="w-4 h-4" />{t("loc.generateQr")}</Button>
      ) : <UpgradeHint text={t("loc.qrLocked")} testId="qr-locked" />}
    </section>
  );
};
